import fetch from 'isomorphic-fetch';
import {/*API_URL,*/API2_URL, PROFILE_SHOW, PROFILE_REQUEST, PROFILE_FAIL, PROFILE_AGENCIES} from "../store/config";
import { newNotification } from "./notifications";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export function fetchProfile(){

	return dispatch => {
		dispatch(profileRequest());

		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};
				return fetch(`${API2_URL}/profile`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(profileData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? error.message:_.values(error), type: "danger"}));
							return dispatch(profileFail(_.values(error)));
						}
					);
			});
	}
}

/*export const profileUpdate = (values, event) => (dispatch) => {
	return dispatch(profileEditUpdate(values,event))
}*/

export const profileUpdate = (values, event) => {

	return dispatch => {
		dispatch(profileRequest());

		return dispatch(sessionService.loadUser)
			.then(sess => {
				let body = new FormData(event);
				let options = {
					headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				};

				_.mapKeys(values, (o,j) => {
					if(o !== null) {
						if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
							body.append(j, o);
						}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});

				return fetch(`${API2_URL}/profile`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							let newsess = {
								...sess,
								profile: json.data
							}
							dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:"El perfil se ha guardado correctamente", type:"success"}));
							//dispatch(loginUserProfile(json.data));
							return sessionService.saveUser(newsess)
								.then(() => dispatch(profileData(json)))
								.catch((error) => profileFail(error))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? error.message:_.values(error), type: "danger"}));
							return dispatch(profileFail(_.values(error)));
						}
					);
			});
	}
}

/* @todo: esta función está despreciada, corroborar para su eliminación */
export const profileAgencies = () => {
    let storage=sessionStorage.getItem("etrans_agencies");
    if( storage === null ){
		const token = sessionStorage.getItem('etrans_user');
		const options = {headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${JSON.parse(token).access_token}`
		},
			method: 'get'
		};

		return dispatch => {
			dispatch(profileRequest());
			return fetch(`${API2_URL}/profile/agencies`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(profileAgenciesData(json.data)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: _.map(error), type: 'danger'}))
						dispatch(profileFail(_.map(error)))
					}
				)
		}
    }
    else{
    	storage=JSON.parse(storage);
    	return dispatch => {
    		dispatch( profileAgenciesData( storage ));
		}
    }
}
/* función depreciada */

const profileData = (json) => {
	return {
		type:PROFILE_SHOW,
		isFetching:false,
		payload:json.data,
		timestamp:Date.now()
	}
}

const profileAgenciesData = (json) => {
	return {
		type: PROFILE_AGENCIES,
		isFetching: false,
		payload: json,
		timestamp: Date.now()
	}
}

const profileRequest = () => {
	return {
		type: PROFILE_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const profileFail = (error) => {
	return {
		type:PROFILE_FAIL,
		isFetching:false,
		error:error,
		timestamp:Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/profile.js